import axios from "axios";

export const createVisit = async (username, visitVOToCreate) => {
    try {
        const {data} = await axios.post("/api/visit/create", {username, visitVOToCreate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const updateVisit = async (username, visitVOToUpdate) => {
    try {
        const {data} = await axios.post("/api/visit/update", {username, visitVOToUpdate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveVisitWithPeople = async (username, visitExternalReference) => {
    try {
        const {data} = await axios.post("/api/visit/viewWithPeople", {username, visitExternalReference});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}
